import classNames from "classnames";
import { FC, memo } from "react";

import { ReactComponent as DangerSquareSVG } from "assets/images/common/danger-square.svg";
import { ReactComponent as SuccessSquareSVG } from "assets/images/common/success-square.svg";

type PropTypes = {
  type: "error" | "success";
  message: string;
  className?: string;
};

const Toast: FC<PropTypes> = ({ type, message, className }) => {
  return (
    <div className={classNames("toast", `toast--${type}`, className)}>
      <span className="toast__icon">{type === "error" ? <DangerSquareSVG /> : <SuccessSquareSVG />}</span>

      <p className="toast__message">{message}</p>
    </div>
  );
};

export default memo(Toast);
